<template>
  <div class="content-center">
    <div class="banner">
      <div class="content">
        <div class="banner-title">微商城电商解决方案</div>
        <div class="line" />
        <div class="desc">
          构建属于零售门店私域流量的专属独立站，帮助门店
          服务触达更多消费者
        </div>
        <div class="btn-wrap">
          <div
            class="btn"
            @click="openModal"
          >免费试用</div>
        </div>
      </div>
    </div>
    <div class="backstage">
      <div class="sk-block-title">
        <div class="title">统一的管理后台</div>
        <div class="sub-title">支持微信、百度、快手等多平台开通微商城，高效卖货</div>
      </div>
      <div class="content">
        <div class="item">
          <img src="@/assets/images/micromall/micromall_backstage1.png" alt="">
          <span>微信小程序</span>
        </div>
        <div class="item">
          <img src="@/assets/images/micromall/micromall_backstage2.png" alt="">
          <span>app商城</span>
        </div>
        <div class="item">
          <img src="@/assets/images/micromall/micromall_backstage3.png" alt="">
          <span>H5商城</span>
        </div>
        <div class="item">
          <img src="@/assets/images/micromall/micromall_backstage4.png" alt="">
          <span>百度小程序</span>
        </div>
        <div class="item">
          <img src="@/assets/images/micromall/micromall_backstage5.png" alt="">
          <span>快手小店</span>
        </div>
      </div>
    </div>
    <div class="retail">
      <div class="sk-block-title">
        <div class="title">线上商城+社群分销+营销互动    助力零售门店数字化升级</div>
      </div>
      <div class="content">
        <div class="left">
          <div class="item">
            <img src="@/assets/images/micromall/micromall_retailIcon1.png" alt="">
            <div class="description">
              <div class="title">搭建专属微商城</div>
              <div class="content">为门店打造专属私域流量平台，除门店自有商品和活动外，平台还额外叠加高频爆款商品及活动协助经营提升</div>
            </div>
          </div>
          <div class="item">
            <img src="@/assets/images/micromall/micromall_retailIcon2.png" alt="">
            <div class="description">
              <div class="title">社群分销裂变</div>
              <div class="content">利用社群熟人经济，帮门店发展代理人，通过代理人的拉新、商品分销，提高店铺品牌知名度和销量</div>
            </div>
          </div>
          <div class="item">
            <img src="@/assets/images/micromall/micromall_retailIcon3.png" alt="">
            <div class="description">
              <div class="title">店铺装修想换就换</div>
              <div class="content">自由拖拽、个性布局，丰富组件样式，多样的主题风格、配色，海量商城模板</div>
            </div>
          </div>
          <div class="item">
            <img src="@/assets/images/micromall/micromall_retailIcon4.png" alt="">
            <div class="description">
              <div class="title">丰富营销促销</div>
              <div class="content">秒杀、限时购、膨胀红包、大转盘、小猫钓鱼、摇奖机、积分乐园等等几十种营销促销活动，帮助门店玩转网店，活跃粉丝</div>
            </div>
          </div>
        </div>
        <div class="right">
          <img src="@/assets/images/micromall/micromall_retailStore1.png" alt="">
          <img src="@/assets/images/micromall/micromall_retailStore2.png" alt="">
        </div>
      </div>
    </div>
    <div class="plugin">
      <div class="sk-block-title">
        <div class="title">持续更新营销活动插件</div>
        <div class="sub-title">秒杀、优惠券等各类主流营销工具，花样玩法，助力商家深挖用户价值</div>
      </div>
      <div class="content">
        <img src="@/assets/images/micromall/micromall_plugin.png" alt="">
      </div>
    </div>
    <div class="doubleWheel">
      <div class="sk-block-title">
        <div class="title">零售+分销，双轮驱动：获客、留存、激活、裂变</div>
        <div class="sub-title">以利益为驱动力，激励用户分享；分销绑定层级，快速引流</div>
      </div>
      <div class="content">
        <img src="@/assets/images/micromall/micromall_doubleWheel.png" alt="">
      </div>
    </div>
    <div class="renovation">
      <div class="sk-block-title">
        <div class="title">店铺随心装修，灵活便捷，模板精美</div>
        <div class="description">
          可视化个性装修，组件随意拖曳，丰富的模板资源，满足不同客户需求，
          不同管理角色，不同管理权限，权责更明确
        </div>
      </div>
      <div class="content">
        <img src="@/assets/images/micromall/micromall_renovation.png" alt="">
      </div>
    </div>
    <IndustrySolution />
    <div class="solution">
      <div class="sk-block-title">
        <div class="title">他们都在用微商城电商解决方案</div>
        <div class="sub-title">赋能零售门店，刷新线上赛道成绩</div>
      </div>
      <div class="content">
        <div class="item">
          <div class="left">
            <div><span class="title">盱眙龙虾</span><span class="sub-title">美食</span></div>
            <div><span class="num">100</span><span class="unit">万+</span></div>
            <div class="saleNum">单日销售数量</div>
            <div class="desc">
              即使面临线下场景被阻断，也能通过线上营销迅速找回客户，突破销量。
            </div>
            <div class="btn" @click="openModal">免费开店</div>
          </div>
          <div class="right">
            <img src="@/assets/images/micromall/micromall_online01.png" alt="">
          </div>
        </div>
        <div class="item">
          <div class="left">
            <div><span class="title">苏垦大米</span><span class="sub-title">农产品</span></div>
            <div><span class="num">2</span><span class="unit">万单</span></div>
            <div class="saleNum">1小时售罄</div>
            <div class="desc">
              直播带货帮助商家获取流量，达到品牌曝光和卖货的双重目的。
            </div>
            <div class="btn" @click="openModal">免费开店</div>
          </div>
          <div class="right">
            <img src="@/assets/images/micromall/micromall_online02.png" alt="">
          </div>
        </div>
        <div class="item">
          <div class="left">
            <div><span class="title">清林家电</span><span class="sub-title">家电</span></div>
            <div><span class="num">8</span><span class="unit">万+</span></div>
            <div class="saleNum">活动期间提升营业额</div>
            <div class="desc">
              利用秒杀和砍价活动通过小程序网店在微信群分享，实现了引流新粉、转化促活。
            </div>
            <div class="btn" @click="openModal">免费开店</div>
          </div>
          <div class="right">
            <img src="@/assets/images/micromall/micromall_online03.png" alt="">
          </div>
        </div>
        <div class="item">
          <div class="left">
            <div><span class="title">快优到家</span><span class="sub-title">百货</span></div>
            <div><span class="num">24</span><span class="unit">万+</span></div>
            <div class="saleNum">分销订单</div>
            <div class="desc">
              通过代理人模式，分销商品销售额占比近30%，销售业绩持续增长。
            </div>
            <div class="btn" @click="openModal">免费开店</div>
          </div>
          <div class="right">
            <img src="@/assets/images/micromall/micromall_online04.png" alt="">
          </div>
        </div>
      </div>
    </div>
    <CarouselItem title="微商城" />
    <ConsultForm info-sources="微商城" />
    <TryModal v-if="visible" :visible="visible" info-sources="微商城" @cancel="modalClose" />
  </div>
</template>

<script>
import metaInfo from '@/common/util/metaInfo'
import IndustrySolution from './components/IndustrySolution'
import ConsultForm from '@/components/ConsultForm'
import TryModal from '@/components/TryModal'
import CarouselItem from '@/components/CarouselItem'

export default {
  metaInfo: metaInfo.Micromall,
  components: {
    IndustrySolution,
    ConsultForm,
    TryModal,
    CarouselItem
  },
  data() {
    return {
      visible: false
    }
  },
  mounted() {

  },
  methods: {
    openModal: function() {
      this.visible = true
    },
    modalClose: function(data) {
      this.visible = data
    }
  }
}
</script>

<style lang="less" scoped>
  .banner {
    background: url("~@/assets/images/micromall/micromall_banner.png") no-repeat center;
    min-width: 1200px;
    background-size: 100% 100%;
    .content {
      width: 1200px;
      margin: 0 auto;
      padding: 53px 0;
      text-align: left;
      .banner-title {
        font-size: 48px;
        color: #FFFFFF;
        line-height: 55px;
      }
      .line {
        width: 100px;
        height: 6px;
        background: #28DAFB;
        margin: 16px 0 31px;
      }
      .desc {
        width: 460px;
        height: 101px;
        font-size: 20px;
        color: #FFFFFF;
        line-height: 28px;
      }
      .btn-wrap {
        .btn {
          width: 200px;
          height: 58px;
          line-height: 58px;
          border-radius: 6px;
          border: 1px solid #FFFFFF;
          font-size: 22px;
          color: #FFFFFF;
          cursor: pointer;
          text-align: center;
          margin-top: 47px;
        }
      }
    }
  }
  .backstage {
    .content {
      display: flex;
      justify-content: space-between;
      width: 1097px;
      margin: 40px auto 0;
      padding-bottom: 60px;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        img {
          width: 123px;
          height: 122px;
        }
        span {
          font-size: 16px;
          font-weight: 500;
          color: #595961;
          line-height: 22px;
          padding-top: 29px;
        }
      }
    }
  }

  .retail {
    background: #fafafa;
    padding-bottom: 37px;
    .content {
      display: flex;
      justify-content: space-between;
      width: 1190px;
      margin: 44px auto 0;
      .left {
        width: 527px;
        padding-top: 39px;
        .item {
          display: flex;
          margin-bottom: 28px;
          img {
            width: 44px;
            height: 44px;
          }
          .description {
            margin-left: 17px;
            text-align: left;
            .title {
              font-size: 24px;
              font-weight: 500;
              color: #595961;
              line-height: 33px;
            }
            .content {
              width: 510px;
              font-size: 16px;
              font-weight: 400;
              color: #8B8FA1;
              margin-top: 10px;
            }
          }
        }
      }
    }
  }

  .plugin {
    padding-bottom: 31px;
    .content {
      width: 1200px;
      margin: 47px auto 0;
    }
  }

  .doubleWheel {
    background: #fafafa;
    padding-bottom: 38px;
    .content {
      width: 1200px;
      margin: 0 auto;
    }
  }

  .renovation {
    padding-bottom: 67px;
    .description {
        width: 660px;
        height: 56px;
        margin: 21px auto 0;
        font-size: 20px;
        font-weight: 400;
        color: #8B8FA1;
        line-height: 28px;
      }
    .content {
      width: 1200px;
      margin: 0 auto;
    }
  }

  .solution {
    padding-bottom: 20px;
    .content {
      display: flex;
      justify-content: space-between;
      width: 1200px;
      margin: 39px auto 0;
      flex-wrap: wrap;
      .item {
        display: flex;
        justify-content: space-between;
        width: 570px;
        height: 320px;
        background: #FFF;
        box-shadow: 0px 0px 10px 0px rgba(221, 221, 221, 0.5);
        border-radius: 6px;
        padding: 40px;
        margin-bottom: 40px;
        .left {
          width: 183px;
          // margin-right: 115px;
          text-align: left;
          .title {
            width: 183px;
            font-size: 24px;
            font-weight: 500;
            color: #595961;
            line-height: 33px;
            padding-right: 14px;
            border-right: 1px solid #D8D8D8;
          }
          .sub-title {
            font-size: 16px;
            font-weight: 400;
            color: #8B8FA1;
            line-height: 22px;
            padding-left: 16px;
          }
          .num {
            font-size: 24px;
            font-weight: 500;
            color: #FF8C11;
            line-height: 33px;
            margin-top: 10px;
          }
          .unit {
            font-size: 14px;
            font-weight: 400;
            color: #8B8FA1;
            line-height: 20px;
            padding-left: 2px;
            margin-top: 10px;
          }
          .saleNum {
            font-size: 14px;
            font-weight: 400;
            color: #8B8FA1;
            line-height: 20px;
            margin-top: 4px;
          }
          .desc {
            height: 90px;
            font-size: 14px;
            font-weight: 400;
            color: #595961;
            line-height: 20px;
            margin-top: 18px;
          }
          .btn {
            width: 104px;
            height: 32px;
            background: #8760F1;
            border-radius: 4px;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 32px;
            text-align: center;
          }
        }
        .right {
          width: 200px;
          height: 240px;
          img {
            display: block;
            width: 200px;
            height: 240px;
          }
        }
      }
    }
  }
</style>
